




import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapGetters, mapState, mapActions } from 'vuex';

import EmployeeDetails from './EmployeeDetails.vue';

@Component
export default class EmployeeDetailsProxy extends Vue {

  modal: any = null;

  public mounted() {
    this.onParamsChange()
  }

  @Watch('$route.params')
  onParamsChange() {
    console.log('$route.params', this.$route.params)
    if(this.modal) {
      this.modal.close();
    }

    this.modal = this.$buefy.modal.open({
      component: EmployeeDetails,
      props: {
        params: this.$route.params
      },
      onCancel: () => {
        this.$router.back()
      },
      hasModalCard: true,
      fullScreen: true,
      customClass: 'document-form',
      parent: this
    })
  }

  beforeDestroy() {
    this.modal.close();
  }

}
